import React, { Component } from "react"
import { fetchKoalaData } from "../apis/koala"
import { bindAll, getComponentDisplayName } from "../utils"

/**
 * Higher order component for Fetching specs.
 * @param {Object} options - Initial config options.
 * @param {String} options.expose - Name of the prop object that contains spec data & methods.
 * @returns {Function} The configured higher order component, which in turn will return a component class.
 */
export default ({ expose = "specs" } = {}) => (Wrapped) => {
  class Specs extends Component {
    constructor(props) {
      super(props)

      this.state = {
        data: false,
        fetchURL: false,
        loading: true
      }

      bindAll(["setOptions", "testMapping", "fetchSpecs", "update"], this)
    }
    /**
     * Set options for specs api on componentDidMount() / componentWillMount()
     * @param {Object} options - Options object.
     * @param {String} options.fetchURL - Url for spec api endpoint.
     * @param {Object} [options.initial] - Initial value for returned data object.
     * @param {Function} options.mapping - A mapping function between api values and state.
     * @param {Function} [callback] - Callback when new options have been updated in state.
     */
    setOptions(options, callback) {
      const {
        fetchURL, initial, mapping, loading
      } = options
      this.setState(
        {
          fetchURL: fetchURL,
          data: initial,
          mapping: mapping,
          loading: loading
        },
        () => {
          if (typeof callback === "function") callback()
        }
      )
    }
    testMapping(stateOptions) {
      let test
      try {
        test = this.state.mapping(stateOptions)
      } catch (error) {
        return false
      }
      return Object.keys(test).every(key => typeof test[key] !== "undefined")
    }
    fetchSpecs(fetchOptions) {
      return fetchKoalaData(this.state.fetchURL, fetchOptions)
    }
    /**
     * Take state object & maps it to API values then makes fetch request & updates state.
     * @param {Object} stateOptions - Options stored in state
     */
    update(stateOptions) {
      this.setState({ loading: true, data: false })
      if (!this.state.fetchURL) return
      const { mapping } = this.state
      let fetchOptions
      if (!Array.isArray(stateOptions)) {
        fetchOptions = (this.testMapping(stateOptions) && mapping(stateOptions)) || {}
      } else {
        fetchOptions = stateOptions.map(optionSet => (this.testMapping(optionSet) && mapping(optionSet)) || {})
      }


      return this.fetchSpecs(fetchOptions)
        .then((specs) => {
          this.setState({ data: specs || false, loading: false })
        })
        .catch(error => console.warn(error))
    }
    render() {
      return (
        <Wrapped
          {...{
            ...this.props,
            [expose]: {
              data: this.state.data,
              setOptions: this.setOptions,
              update: this.update,
              loading: this.state.loading
            }
          }} />
      )
    }
  }

  Specs.displayName = `Specs(${getComponentDisplayName(Wrapped)})`

  return Specs
}



// WEBPACK FOOTER //
// ./src/higher-order-components/specs.jsx